import typesAccess from './typesAccess'
import sosListReasons from './sosListReasons'
import qualityService from './qualityService'
import interview from './interview'
import documentsOrder from './documentsOrder'
import loyaltyProgramMap from './loyaltyProgramMap'
import loyaltyProgram from './loyaltyProgram'
import serviceOrder from './serviceOrder'

export default {
  namespaced: true,
  modules: {
    typesAccess,
    sosListReasons,
    qualityService,
    interview,
    documentsOrder,
    loyaltyProgramMap,
    loyaltyProgram,
    serviceOrder
  }
}
